export const experiences = [
  {
    company: 'Stealth Startup',
    role: 'Software Engineer Intern (Engineer #3)',
    location: 'New York City, NY',
    period: 'Dec 2025 - Present',
    description: 'Building agentic AI infrastructure from the ground up — tool orchestration, streaming inference pipelines, and production-grade LLM systems.',
    tech: ['Python', 'TypeScript', 'AI/LLM', 'Tool Calling']
  },
  {
    company: 'MedSender',
    role: 'Backend Engineer Intern',
    location: 'New York City, NY',
    period: 'May 2025 - Dec 2025',
    description: 'Shipped ML pipelines that cut manual work by 70% and hit 99.3% accuracy. Replaced legacy systems, reduced latency 90%+, and built infrastructure handling thousands of daily transactions.',
    tech: ['Ruby on Rails', 'Python', 'Redis', 'Elasticsearch', 'Docker']
  },
  {
    company: 'IIC UWaterloo',
    role: 'Software Engineer',
    location: 'Waterloo, ON',
    period: 'May 2024 - Aug 2024',
    description: 'Built sponsor-facing pages and internal tooling. Improved search performance 20% and automated workflows that cut manual errors by 30%.',
    tech: ['TypeScript', 'Next.js', 'Google App Script']
  },
  {
    company: 'Kenna Technologies',
    role: 'Fullstack Developer Intern',
    location: 'Mississauga, ON',
    period: 'Jan 2024 - Apr 2024',
    description: 'Led a full-stack migration from legacy Lotus Notes to modern React/Node/SQL. Reduced API overhead by 87.5% through deep workflow optimization.',
    tech: ['TypeScript', 'React', 'Node.js', 'SQL']
  },
  {
    company: 'Coach Chihab Group',
    role: 'Software Engineer',
    location: 'Burlington, ON',
    period: 'Sep 2023 - Dec 2023',
    description: 'Built a real-time check-in platform that cut guest wait times by 95% for 50+ attendee events.',
    tech: ['Vue.js', 'Firebase']
  }
];
